import React, { useState } from "react";
import PropTypes from "prop-types";
// ui
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
// style
import { createStyles, makeStyles, styled, alpha } from "@material-ui/styles";
// component
import ButtonMain from "../button/ButtonMain";
import { isElement } from "../../utils/reactHelper";
// utils

//
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {},
  })
);

const StyledMenu = styled(Menu)(({ theme }) => ({
  "& .MuiPopover-paper": {
    minWidth: "200px",
  },
}));

const renderMenuItem = (menuItems) => {
  if (Array.isArray(menuItems)) {
    return menuItems
      .filter((item) => isElement(item.children))
      .map(
        ({ children, useMenuItem = true, ...rest }, idx) =>
          (useMenuItem === false && (
            <div key={idx.toString()}>{children}</div>
          )) || (
            <MenuItem key={idx.toString()} {...rest}>
              {children}
            </MenuItem>
          )
      );
  }
  if (isElement(menuItems)) {
    return menuItems;
  }
  return null;
};

//
const ButtonPopup = ({ badgeProps, buttonProps, menuProps }) => {
  // style
  const classes = useStyles();
  // props
  const { onButtonIconClick, ...restBtnProps } = buttonProps;
  const { header, body, footer, onClose, ...restMenuProps } = menuProps;

  // local state
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (onButtonIconClick) onButtonIconClick(event);
  };
  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) onClose();
  };

  return (
    <Box>
      <ButtonMain
        badgeProps={badgeProps}
        buttonProps={{
          ...restBtnProps,
          onClick: handleClick,
        }}
      />
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        {...restMenuProps}
      >
        {header && renderMenuItem(header)}
        {header && body && <Divider />}
        {body && renderMenuItem(body)}
        {body && footer && <Divider />}
        {footer && renderMenuItem(footer)}
      </StyledMenu>
    </Box>
  );
};

ButtonPopup.propTypes = {
  badgeProps: PropTypes.objectOf(PropTypes.any),
  buttonProps: PropTypes.objectOf(PropTypes.any),
  menuProps: PropTypes.objectOf(PropTypes.any),
};

ButtonPopup.defaultProps = {
  badgeProps: {},
  buttonProps: {},
  menuProps: {},
};

export default ButtonPopup;
